import { Close } from "@mui/icons-material";
import { Box, Checkbox, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";
import PhoneNumberInput from "src/components/shared/PhoneNumberInput";
import SearchList from "src/components/shared/SearchList";

const VIETNAM = "Vietnam";

const RequiredLabel = ({ children, required = false }) => {
  return (
    <>
      {children}
      {required && (
        <span
          style={{
            color: "red",
            marginLeft: 2,
          }}
        >
          *
        </span>
      )}
    </>
  );
};

export default function CustomerAddress({ setCustomerDetail, customerDetail, index, initialShow = false }) {
  const address = customerDetail?.customerAddresses?.[index];

  const onRemove = () => {
    const addresses = customerDetail?.customerAddresses?.filter((_, i) => i !== index);

    setCustomerDetail({
      ...customerDetail,
      customerAddresses: addresses,
    });
  };

  const onChange = (name, value) => {
    const addresses = [...(customerDetail?.customerAddresses ?? [])];

    addresses[index] = {
      ...addresses[index],
      [name]: value,
    };

    setCustomerDetail({
      ...customerDetail,
      customerAddresses: addresses,
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(address?.isDefault)}
              onChange={(e) => onChange("isDefault", e.target.checked)}
            />
          }
          label="Đặt làm địa chỉ mặc định"
        />

        {index !== 0 && (
          <IconButton
            onClick={onRemove}
            sx={{
              width: "18px",
              height: "18px",
              background: "var(--grey) !important",
            }}
          >
            <Close sx={{ width: "16px" }} />
          </IconButton>
        )}
      </Box>

      <TextField
        label={<RequiredLabel required>Người nhận</RequiredLabel>}
        fullWidth
        value={address?.recipientName ?? ""}
        onChange={(e) => onChange("recipientName", e.target.value)}
      />

      <SearchList
        disabled={!address?.recipientName}
        params={{
          path: "/api/v1/countries",
          params: {
            searchField: "name",
            sortField: "order",
            sortOrder: "asc",
          },
        }}
        label="Quốc gia"
        initialShow={initialShow}
        value={address?.country || ""}
        onChange={(_, newValue) => onChange("country", newValue)}
      />

      <PhoneNumberInput
        disabled={!address?.country}
        name="phone"
        label="Số điện thoại"
        width="100%"
        required
        value={address?.phone ?? ""}
        onChange={(e) => onChange("phone", e)}
      />

      <TextField
        disabled={!address?.phone}
        label={<RequiredLabel required>Địa chỉ cụ thể</RequiredLabel>}
        fullWidth
        value={address?.detailAddress ?? ""}
        onChange={(e) => onChange("detailAddress", e.target.value)}
      />

      {address?.country?.name === VIETNAM && (
        <>
          <FormControl>
            <RadioGroup
              row
              value={address?.addressLevel ?? 2}
              onChange={(e) => onChange("addressLevel", Number(e.target.value))}
            >
              <FormControlLabel
                value={2}
                control={<Radio />}
                label="Địa chỉ 2 cấp"
              />

              <FormControlLabel
                value={3}
                control={<Radio />}
                label="Địa chỉ 3 cấp"
              />
            </RadioGroup>
          </FormControl>

          <Box
            display="flex"
            gap={2}
            flexDirection="column"
          >
            <SearchList
              params={{
                path: "/api/v1/addresses/provinces",
                params: {
                  searchField: "name",
                  version: Number(address?.addressLevel),
                },
              }}
              label="Thành phố/ Tỉnh"
              value={address?.province || address?.ward?.province || address?.ward?.district?.province || ""}
              onChange={(_, newValue) => onChange("province", newValue)}
            />
          </Box>

          {(address?.addressLevel ?? 2) !== 2 && (
            <SearchList
              disabled={!address?.province && (address?.addressLevel ?? 2) !== 2}
              params={{
                path: "/api/v1/addresses/districts",
                params: {
                  searchField: "name",
                  version: Number(address?.addressLevel),
                },
              }}
              label="Quận/ Huyện"
              value={address?.district || address?.ward?.district || ""}
              onChange={(_, newValue) => onChange("district", newValue)}
            />
          )}

          <SearchList
            disabled={!address?.province}
            label="Phường/ Xã"
            value={address?.ward || ""}
            onChange={(_, newValue) => onChange("ward", newValue)}
            params={{
              path: "/api/v1/addresses/wards",
              params: {
                district: address?.district?._id || undefined,
                province: address?.province?._id || undefined,
                version: Number(address?.addressLevel),
              },
            }}
          />
        </>
      )}
    </Box>
  );
}
